'use client'

import { useEffect, useState } from 'react'
import { fetchPlanPrices } from '../lib/plan-prices'

/** v2's plan prices for this account (src/lib/plan-prices.js): `{ sale, plans }`, or null until they arrive or when
 *  they cannot be had. The header's sale banner reads its `sale`, as useGemPrices' answer does for gems. */
export default function usePlanPrices(user, authResolved) {
  const [answer, setAnswer] = useState(null)
  useEffect(() => {
    if (!authResolved) return
    let live = true
    ;(async () => {
      const token = user ? await user.getIdToken() : null
      const prices = await fetchPlanPrices(token)
      if (live) setAnswer(prices)
    })()
    return () => {
      live = false
    }
  }, [user, authResolved])
  return answer
}
